/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 30th 2022, 7:56:53 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { AUTOMATED_TASK_TYPES } from "lib/schemas";
import Grid from "@mui/material/Grid";
import { TaskTemplate } from "lib/schemas";
import { SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS } from "./TaskTypeWidgets";
import { TaskTypeSelectorButton } from "./TaskTypeSelectorButton";

interface AutomatedTaskTypeSelectorProps {
  saveNewTaskInfo: (optionalProperties: Partial<TaskTemplate>) => void;
}

export const AutomatedTaskTypeSelector = (props: AutomatedTaskTypeSelectorProps) => {
  const [selectedAutomatedTaskType, setSelectedAutomatedTaskType] =
    React.useState<TaskTemplate["automated_task_type"]>();

  const onChooseAutomatedTaskType = (automated_task_type: keyof typeof AUTOMATED_TASK_TYPES, event) => {
    props.saveNewTaskInfo({ automated_task_type });
  };

  return (
    <>
      {Object.keys(SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS).map(
        (automatedTaskTypeKey: TaskTemplate["automated_task_type"]) => {
          const {
            automatedTaskTypeIcon,
            automatedTaskTypeTitle,
            automatedTaskTypeDescription,
            AdditionalInfoComponent,
          } = SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS[automatedTaskTypeKey];
          return (
            <Grid item md={4} key={automatedTaskTypeKey}>
              <TaskTypeSelectorButton
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                  if (AdditionalInfoComponent) {
                    setSelectedAutomatedTaskType(automatedTaskTypeKey);
                    return;
                  }

                  onChooseAutomatedTaskType(
                    automatedTaskTypeKey as keyof typeof SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS,
                    event
                  );
                }}
                tooltipText={automatedTaskTypeDescription}
                customIcon={automatedTaskTypeIcon}
                customTitle={automatedTaskTypeTitle}
                bpmnNodeType="Handler"
              />
              {AdditionalInfoComponent ? (
                <AdditionalInfoComponent
                  handleClose={() => setSelectedAutomatedTaskType(null)}
                  isOpen={selectedAutomatedTaskType === automatedTaskTypeKey}
                  saveNewTaskInfo={props.saveNewTaskInfo}
                />
              ) : null}
            </Grid>
          );
        }
      )}
    </>
  );
};
